import { Fragment } from 'react'
import { OrgCardSkeleton } from '.'

const ORGANIZATIONS_GRID_SKELETON_COUNT = 6

export function OrganizationsGridSkeleton() {
  return (
    <>
      {Array.from({ length: ORGANIZATIONS_GRID_SKELETON_COUNT }).map((_, index) => (
        <Fragment key={index}>
          <OrgCardSkeleton />
        </Fragment>
      ))}
    </>
  )
}
